// src/app/services/animation.service.ts
import { Injectable } from '@angular/core';
import { createAnimation, Animation } from '@ionic/core';

@Injectable({ providedIn: 'root' })
export class AnimationService {
  fadeSlide(el: HTMLElement, options?: { duration?: number; easing?: string }) {
    if (!el) return;
    const anim = createAnimation()
      .addElement(el)
      .duration(options?.duration || 400)
      .easing(options?.easing || 'cubic-bezier(0.36,0.66,0.04,1)')
      .fromTo('opacity', '0', '1')
      .fromTo('transform', 'translateY(20px)', 'translateY(0)');
    anim.play();
  }

  fadeOut(el: HTMLElement, options?: { duration?: number }) {
    if (!el) return;
    const anim = createAnimation()
      .addElement(el)
      .duration(options?.duration || 300)
      .easing('ease-out')
      .fromTo('opacity', '1', '0')
      .fromTo('transform', 'translateY(0)', 'translateY(20px)');
    anim.play();
  }

  throbbingFade(
    el: HTMLElement,
    options?: { duration?: number; scale?: number; iterations?: number }
  ): Animation | undefined {
    if (!el) return;

    const duration = options?.duration || 600; // one fade-in + fade-out cycle
    const scaleAmount = options?.scale || 1.05; // slight scale for “throb”
    const iterations = options?.iterations || Infinity; // repeat indefinitely

    const anim = createAnimation()
      .addElement(el)
      .duration(duration)
      .iterations(iterations)
      .keyframes([
        { offset: 0, opacity: '0.3', transform: 'scale(1)' },
        { offset: 0.5, opacity: '1', transform: `scale(${scaleAmount})` },
        { offset: 1, opacity: '0.3', transform: 'scale(1)' },
      ]);

    anim.play();
    return anim; // return the animation instance so you can stop it later if needed
  }
}
